<!-- Intro Header -->
<header class="sdg-status">
  <div class="intro-body">
    <div class="container">
      <div class="col-md-12">
        <div class="row" appDynamicDirection>
          <div class="col-sm-6 title">
            <h4 class="page-heading"i18n>Water-Related Sustainable Development Goals</h4>
            <h2 class="intro-text" i18n>Status - Reporting</h2>
          </div>
          <div class="col-sm-6">

            <!-- <a  (click) = "resourcesBtnClick()" class="col-xs-12 col-sm-6 col-md-8 btn btn-circle-sm text-center " style="margin-bottom: 15px;">
              <span i18n>Resources</span>
            </a> -->
            <a (click) = "quesBtnClick()" class="col-xs-12 col-sm-6 col-md-8 btn btn-circle-sm text-center " style="margin-bottom: 15px;">
              <span i18n>Questionnaire</span>
            </a>
            <!-- <a (click) = "dataBtnClick()" class="col-xs-12 col-sm-6 col-md-8 btn btn-circle-sm text-center" style="margin-bottom: 15px;">
              <span i18n>Data</span>
            </a> -->
            <a (click) = "reportBtnClick()" class="col-xs-12 col-sm-6 col-md-8 btn btn-circle-sm text-center" style="margin-bottom: 15px; background: #1f487c;">
              <span i18n>Reporting</span>
            </a>

            <a (click) = "exportBtnClick()" class="btn btn-circle-sm text-center" style="margin-bottom: 15px;" [class.disabledanchor]="loading">
              <span i18n>Generate<br/>PDF</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>

<div class="chartWrapper">
  <div class="chartAreaWrapper">
    <canvas id="canvas1" style="width: 1200px; height: 700px;" width="1200" height="700">{{ chart1 }}</canvas>
  </div>
</div>

<div class="chartWrapper">
  <div class="chartAreaWrapper">
    <canvas id="canvas2" style="width: 1200px; height: 700px;" width="1200" height="700">{{ chart2 }}</canvas>
  </div>
</div>

<div class="chartWrapper">
  <div class="chartAreaWrapper">
    <canvas id="canvas3"  style="width: 1200px; height: 700px;" width="1200" height="700">{{ chart3 }}</canvas>
  </div>
</div>

<div class="chartWrapper">
  <div class="chartAreaWrapper">
    <canvas id="canvas4" style="width: 1200px; height: 700px;" width="1200" height="700">{{ chart4 }}</canvas>
  </div>
</div>

<div class="chartWrapper">
  <div class="chartAreaWrapper">
    <canvas id="canvas5" style="width: 1200px; height: 700px;" width="1200" height="700">{{ chart5 }}</canvas>
  </div>
</div>

<div class="chartWrapper">
  <div class="chartAreaWrapper">
    <canvas id="canvas6" style="width: 1200px; height: 700px;" width="1200" height="700">{{ chart6 }}</canvas>
  </div>
</div>

<div class="chartWrapper">
  <div class="chartAreaWrapper">
    <canvas id="canvas7" style="width: 1200px; height: 700px;" width="1200" height="700">{{ chart7 }}</canvas>
  </div>
</div>

<div class="chartWrapper">
  <div class="chartAreaWrapper">
    <canvas id="canvas8" style="width: 1200px; height: 700px;" width="1200" height="700">{{ chart8 }}</canvas>
  </div>
</div>

<div class="chartWrapper">
  <div class="chartAreaWrapper">
    <canvas id="canvas9" style="width: 1200px; height: 700px;" width="1200" height="700">{{ chart9 }}</canvas>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/sdg/status-report/status-report.component.html